let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  const callbacks = subscribers[eventName];

  if (!callbacks?.length) {
    return Promise.resolve([]);
  }

  const executions = callbacks.map((callback) => {
    try {
      return Promise.resolve(callback(data)).catch((error) => {
        console.error(`[pubsub] async subscriber failed for "${eventName}"`, error);
        return undefined;
      });
    } catch (error) {
      console.error(`[pubsub] subscriber failed for "${eventName}"`, error);
      return Promise.resolve(undefined);
    }
  });

  return Promise.all(executions);
}
